module.exports = "/_next/static/images/umbrella-line-b7ccb05daf4297108c22c4c93fa3f051.svg";